// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CoverMyMedsV1ClientGeneratedAddressModel } from './coverMyMedsV1ClientGeneratedAddressModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsV1ClientGeneratedPatientModel {
    'cellPhone'?: string | null;
    'dateOfBirth'?: Moment;
    'email'?: string | null;
    'firstName'?: string | null;
    'gender'?: string | null;
    'homePhone'?: string | null;
    'lastName'?: string | null;
    'middleName'?: string | null;
    'patientContactMethods'?: Array<string> | null;
    'primaryAddress'?: CoverMyMedsV1ClientGeneratedAddressModel | null;
    'voicemailConsent'?: boolean | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsV1ClientGeneratedPatientModel>> = [
        {
            "name":     "cellPhone",
            "baseName": "cellPhone",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "Date"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "string"
        },
        {
            "name":     "homePhone",
            "baseName": "homePhone",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "patientContactMethods",
            "baseName": "patientContactMethods",
            "type":     "Array<string>"
        },
        {
            "name":     "primaryAddress",
            "baseName": "primaryAddress",
            "type":     "CoverMyMedsV1ClientGeneratedAddressModel"
        },
        {
            "name":     "voicemailConsent",
            "baseName": "voicemailConsent",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsV1ClientGeneratedPatientModel.attributeTypeMap;
    }
}
